import { useState } from 'react'
import { Link } from 'react-router-dom'
import {
  useNotificacaoContagem,
  useNotificacaoList,
  useNotificacaoMarcarLida,
  useNotificacaoMarcarTodasLidas,
} from '../../hooks/useNotificacoes'

const NIVEL_COR: Record<string, string> = {
  info: '#1565C0',
  warning: '#F57C00',
  critical: '#C62828',
}

export default function NotificacoesBadge() {
  const [aberto, setAberto] = useState(false)
  const contagem = useNotificacaoContagem()
  const lista = useNotificacaoList({ lida: false })
  const marcarLida = useNotificacaoMarcarLida('')
  const marcarTodas = useNotificacaoMarcarTodasLidas()

  const total = contagem.data?.nao_lidas ?? 0
  const criticas = contagem.data?.criticas_nao_lidas ?? 0
  const items = lista.data?.results.slice(0, 10) ?? []

  return (
    <div style={{ position: 'relative' }} data-testid="notif-container">
      <button
        type="button"
        onClick={() => setAberto((v) => !v)}
        aria-label="Notificações"
        aria-expanded={aberto}
        data-testid="notifications-trigger"
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          fontSize: '1.25rem',
          position: 'relative',
          padding: '0.25rem 0.5rem',
        }}
      >
        🔔
        {total > 0 && (
          <span
            data-testid="notifications-badge"
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              background: criticas > 0 ? '#C62828' : '#1565C0',
              color: 'white',
              borderRadius: '999px',
              padding: '0.1rem 0.4rem',
              fontSize: '0.7rem',
              minWidth: '1.2rem',
              textAlign: 'center',
            }}
          >
            {total > 99 ? '99+' : total}
          </span>
        )}
      </button>

      {aberto && (
        <>
          <div
            onClick={() => setAberto(false)}
            style={{
              position: 'fixed',
              inset: 0,
              zIndex: 99,
            }}
          />
          <div
            data-testid="notif-dropdown"
            style={{
              position: 'absolute',
              top: '100%',
              right: 0,
              width: '360px',
              maxHeight: '480px',
              overflowY: 'auto',
              background: 'white',
              border: '1px solid #E0E0E0',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              borderRadius: '6px',
              zIndex: 100,
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0.75rem 1rem',
                borderBottom: '1px solid #E0E0E0',
              }}
            >
              <strong>Notificações</strong>
              {total > 0 && (
                <button
                  type="button"
                  onClick={() => marcarTodas.mutate()}
                  disabled={marcarTodas.isPending}
                  style={{
                    fontSize: '0.8rem',
                    background: 'none',
                    border: 'none',
                    color: '#1565C0',
                    cursor: 'pointer',
                  }}
                  data-testid="btn-marcar-todas-lidas"
                >
                  Marcar todas como lidas
                </button>
              )}
            </div>

            {lista.isLoading && <div style={{ padding: '1rem' }}>Carregando...</div>}
            {!lista.isLoading && items.length === 0 && (
              <div style={{ padding: '1rem', color: '#666', fontStyle: 'italic' }}>
                Nenhuma notificação não-lida.
              </div>
            )}

            {items.map((n) => (
              <div
                key={n.id}
                data-testid={`notif-item-${n.id}`}
                style={{
                  padding: '0.75rem 1rem',
                  borderBottom: '1px solid #F0F0F0',
                  borderLeft: `4px solid ${NIVEL_COR[n.nivel] ?? '#888'}`,
                  cursor: n.link ? 'pointer' : 'default',
                }}
                onClick={() => {
                  marcarLida.reset()
                  void marcarLida.mutateAsync().catch(() => {})
                  if (n.link) window.location.href = n.link
                }}
              >
                <div style={{ fontWeight: 600, fontSize: '0.9rem' }}>{n.titulo}</div>
                <div style={{ fontSize: '0.85rem', color: '#444', marginTop: '0.25rem' }}>
                  {n.mensagem}
                </div>
                <div style={{ fontSize: '0.7rem', color: '#888', marginTop: '0.25rem' }}>
                  {new Date(n.criada_em).toLocaleString('pt-BR')}
                </div>
              </div>
            ))}

            <div
              style={{
                padding: '0.5rem 1rem',
                borderTop: '1px solid #E0E0E0',
                textAlign: 'center',
              }}
            >
              <Link
                to="/notificacoes"
                onClick={() => setAberto(false)}
                style={{ fontSize: '0.85rem', color: '#1565C0' }}
              >
                Ver todas →
              </Link>
            </div>
          </div>
        </>
      )}
    </div>
  )
}
